import React from "react";
import { useAuth } from "../context/AuthContext";
import { Typography, Box } from "@mui/material";

const Home = () => {
  const { user } = useAuth();

    return (
        <Box sx={{ maxWidth: "96%", margin: "auto", mt: 5 }}>
        <Typography variant="h5" align="center" gutterBottom>
          Please select menu to work. 
        </Typography>
        <Typography variant="h6" align="center" gutterBottom>
          {user ? 
            (<span>User : {user.username} , Email : {user.email}</span>) : (<p>Loading...</p>)
          }
        </Typography>
    </Box>
        
    );
};

export default Home;
